import { generateStripeState } from '../helper'

const options = {
  api: {
    list: ({ customer }) => `/api/stripe/customer/${customer}/balances`,
    update: ({ customer, id }) => `/api/stripe/customer/${customer}/balance/${id}`,
    create: ({ customer }) => `/api/stripe/customer/${customer}/balance`,
    get: ({ customer, id }) => `/api/stripe/customer/${customer}/balance/${id}`,
  },
  state: {
    collectionName: 'customerBalances'
  },
  getters: {
    getPagination: 'getCustomerBalancePagination',
    getCollection: 'getCustomerBalances'
  },
  actions: {
    list: 'listCustomerBalances',
    update: 'updateCustomerBalance',
    create: 'createCustomerBalance',
    get: 'getCustomerBalance',
  },
  mutationKey: 'CUSTOMER_BALANCE',
}

const {
  state: stripeState,
  getters: stripeGetters,
  actions: stripeActions,
  mutations: stripeMutations
} = generateStripeState(options)

export default {
  state: {
    ...stripeState
  },
  getters: {
    ...stripeGetters
  },
  mutations: {
    ...stripeMutations
  },
  actions: {
    ...stripeActions
  }
}
